module.exports = __webpack_public_path__ + "u11.no2.1d9e0bc4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/nakagawa/u11.no2.jpg
// module id = 8R/I
// module chunks = 0